import React from 'react';
import { Image, UserCheck, X } from 'lucide-react';
import styles from './IdentityTable.module.scss';
import StatusBadge from '../Shared/StatusBadge.tsx';

interface IdentityTableProps {
  users: any[];
  onViewImages: (user: any) => void;
  onValidate: (userId: string, isValid: boolean) => void;
}

const IdentityTable: React.FC<IdentityTableProps> = ({
  users,
  onViewImages,
  onValidate
}) => {
  const getUserFromRow = (row: any) => row?.user ?? row?.jobBoard ?? row;

  const getIdentityStatus = (row: any) => {
    const nestedUser = getUserFromRow(row);
    return nestedUser?.identity_validated ?? null;
  };

  const getUserDisplayName = (row: any) => {
    const nestedUser = getUserFromRow(row);
    if (nestedUser?.type === 'COMPANY') {
      return nestedUser?.razon_social || 'Empresa';
    }
    const fullName = [nestedUser?.name, nestedUser?.last_name].filter(Boolean).join(' ').trim();
    return fullName || nestedUser?.name || 'Usuario';
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Estado</th>
            <th>Imágenes</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => {
            const nestedUser = getUserFromRow(user);
            const userId = nestedUser?.id ?? user?.id;
            const userName = getUserDisplayName(user);
            const userEmail = nestedUser?.email ?? nestedUser?.username ?? user?.email ?? '-';
            const identityValidated = getIdentityStatus(user);
            return (
            <tr key={index}>
              <td>{userId}</td>
              <td>{userName}</td>
              <td>{userEmail}</td>
              <td>
                <StatusBadge 
                  status={identityValidated} 
                  type="identity"
                />
              </td>
               <td>
                <button
                  className={styles.viewButton}
                  onClick={() => onViewImages(user)}
                >
                  <Image size={16} />
                  Ver
                </button>
              </td>
              <td>
                {identityValidated === null ? (
                  <div className={styles.actionButtons}>
                    <button
                      className={styles.approveButton}
                      onClick={() => userId && onValidate(String(userId), true)}
                    >
                      <UserCheck size={16} />
                      Aceptar
                    </button>
                    <button
                      className={styles.rejectButton}
                      onClick={() => userId && onValidate(String(userId), false)}
                    >
                      <X size={16} />
                      Rechazar
                    </button>
                  </div>
                ) : identityValidated === false ? (
                  <button className={styles.rejectButton} disabled>
                    <X size={16} />
                    Rechazado
                  </button>
                ) : (
                  <button className={styles.approveButton} disabled>
                    <UserCheck size={16} />
                    Validado
                  </button>
                )}
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default IdentityTable;

